import { render, staticRenderFns } from "./FriendTagEditor.vue?vue&type=template&id=2d70c374&scoped=true"
import script from "./FriendTagEditor.vue?vue&type=script&lang=js"
export * from "./FriendTagEditor.vue?vue&type=script&lang=js"
import style0 from "./FriendTagEditor.vue?vue&type=style&index=0&id=2d70c374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70c374",
  null
  
)

export default component.exports